<template>
    <TopNav></TopNav>
		<h1>Roman Numerals Converter</h1>
		<fieldset>
      <legend>Roman Numerals Converter</legend>
      <label for="k">Number: </label><input type="number" v-model.number="inputValue" id="k" min="1" max="3999" step="1">
      <br><br>
      Roman number: <span class="blue">{{ outputValue }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'

const roman = {
  1: 'I',
  2: 'II',
  3: 'III',
  4: 'IV',
  5: 'V',
  6: 'VI',
  7: 'VII',
  8: 'VIII',
  9: 'IX',
  10: 'X',
  20: 'XX',
  30: 'XXX',
  40: 'XL',
  50: 'L',
  60: 'LX',
  70: 'LXX',
  80: 'LXXX',
  90: 'XC',
  100: 'C',
  200: 'CC',
  300: 'CCC',
  400: 'CD',
  500: 'D',
  600: 'DC',
  700: 'DCC',
  800: 'DCCC',
  900: 'CM',
  1000: 'M',
  2000: 'MM',
  3000: 'MMM'
}

export default {
  name: "RomanNumerals",
  data() {
    return {
      inputValue: 1,
      outputValue: 'I'
    }
  },
  components: {
    TopNav
  },
  watch: {
    inputValue: function (natural) {
      let str = String(natural).split('');
      let result = '';
      for (let i = 0; i < str.length; i++) {
        var lookup = str[i] * Math.pow(10, str.length - i - 1);
        if (roman[lookup]) {
          result += roman[lookup];
        }
      }
      this.outputValue = result;
    }
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

label {
  display: inline-block;
  width: 100px;
}

footer section a {
  margin: 20px;
}

.blue {
    color: blue;
}
</style>
